import React from 'react'
import { Route } from 'react-router-dom'
import Profile from 'src/modules/Profile'

const route = <Route exact path="/profile" element={<Profile />} />

export default route
